import { BookOpenTextIcon, ClipboardCheckIcon, LightbulbIcon, SearchIcon, SettingsIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  listLabel?: string;
  items?: string[];
  note?: string;
  benefit?: string;
  value: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Actividades y Desafíos para Enseñar Minería',
    description:
      '150 propuestas listas para utilizar o adaptar en clases sobre fundamentos, geología, exploración, explotación, procesamiento, seguridad, ambiente, sostenibilidad y sociedad. Organizadas por nivel de dificultad.',
    note: 'Incluyen actividades de análisis, comparación, resolución de problemas, interpretación, argumentación y reflexión.',
    benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '02',
    title: 'Kit de Evaluación Docente de Minería',
    description: 'Recursos completos para evaluar conocimientos y competencias:',
    items: [
      'Evaluaciones diagnósticas',
      'Evaluaciones temáticas',
      'Evaluaciones integradoras',
      'Preguntas de respuesta breve y desarrollo',
      'Verdadero o falso con justificación',
      'Detección y corrección de errores',
      'Criterios de orientación para el docente',
      'Rúbricas',
      'Listas de cotejo',
    ],
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Casos y Situaciones Problemáticas de Minería para el Aula',
    description:
      '100 situaciones educativas ficticias para que los estudiantes apliquen conocimientos en contextos problemáticos.',
    listLabel: 'Los casos permiten trabajar:',
    items: [
      'Exploración y evaluación de recursos',
      'Explotación minera',
      'Procesamiento de minerales',
      'Seguridad en minería',
      'Ambiente y sostenibilidad',
      'Comunidades y sociedad',
      'Situaciones integradoras',
    ],
    note: 'Promoviendo análisis de información, identificación de problemas, comparación de alternativas y justificación de respuestas.',
    benefit: 'Tus alumnos aprenden analizando situaciones reales de minería.',
    value: 'USD 14',
    icon: SearchIcon,
  },
  {
    number: '04',
    title: 'Diccionario Docente de Minería: 200 Conceptos Explicados para el Aula',
    description:
      'Una herramienta de consulta con 200 conceptos fundamentales de minería explicados de forma clara y educativa.',
    listLabel: 'Incluye terminología relacionada con:',
    items: [
      'Minerales y propiedades',
      'Geología aplicada',
      'Exploración y recursos',
      'Explotación minera',
      'Procesamiento y beneficio',
      'Seguridad minera',
      'Gestión ambiental',
      'Sostenibilidad',
      'Sociedad y comunidades',
      'Enseñanza de la minería',
    ],
    note: 'Ideal para consultar conceptos rápidamente, reforzar explicaciones y facilitar la comprensión.',
    value: 'USD 14',
    icon: BookOpenTextIcon,
  },
  {
    number: '05',
    title: '50 Proyectos Educativos de Minería para el Aula',
    description:
      'Una colección de 50 proyectos educativos para desarrollar los contenidos con propuestas de mayor profundidad y duración.',
    listLabel: 'Los proyectos permiten trabajar:',
    items: [
      'Investigación',
      'Análisis de problemas',
      'Resolución de situaciones',
      'Argumentación',
      'Integración de conocimientos',
      'Elaboración de productos finales',
    ],
    note: 'Abordando diferentes áreas de la minería. Cada proyecto incluye objetivos, procedimientos y recursos necesarios.',
    benefit: 'Tus alumnos salen con proyectos reales en sus portafolios.',
    value: 'USD 14',
    icon: SettingsIcon,
  },
];
